import React, { useEffect, useState, createContext, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../utils/api";
import { scheduleLogout } from "../../utils/scheduleLogout";
import { toast } from "react-toastify";
import { unsubscribeUserFromPush } from "../../utils/notification.js"; // ✅ import here

const LogoutContext = createContext();

export const LogoutProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const logoutTimerRef = useRef(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      setUser(parsed);

      if (parsed?.jwt_token) {
        logoutTimerRef.current = scheduleLogout(parsed.jwt_token, logout);
      }
    }
  }, []);

  const logout = async () => {
    try {
      const storedUser = localStorage.getItem("user");
      let token = null;

      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        token = parsedUser?.jwt_token;
      }

      // ✅ Step 1: Unsubscribe push first
      // const temp = await unsubscribeUserFromPush();
      // console.log("Unsub status = ",temp)

      // ✅ Step 2: Inform backend
      if (token) {
        await apiFetch("/api/auth/logout", { method: "POST" });
      }

      toast.success("You have been logged out successfully!");
    } catch (err) {
      console.error("Logout failed:", err);
      toast.error("Logout failed, please try again!");
    } finally {
      // ✅ Step 3: Clear everything
      clearTimeout(logoutTimerRef.current);
      localStorage.removeItem("user");
      localStorage.removeItem("isRequesting");
      setUser(null);

      // ✅ Step 4: Navigate away
      navigate("/signin", { replace: true });
    }
  };

  useEffect(() => {
    if (user?.jwt_token) {
      clearTimeout(logoutTimerRef.current);
      logoutTimerRef.current = scheduleLogout(user.jwt_token, logout);
    }
  }, [user]);

  return (
    <LogoutContext.Provider value={{ user, setUser, logout }}>
      {children}
    </LogoutContext.Provider>
  );
};

export const useLogout = () => useContext(LogoutContext);
